import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechDialogsService } from '../tech-dialogs.service';
import { TechErrorDialogModel } from './techerror_dialog.model';
import { Router } from '@angular/router';

@Component({
  selector: 'thr-techerrordialog',
  templateUrl: './techerror_dialog.component.html',
  styleUrls: ['./techerror_dialog.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('250ms ease-out', style({ height: 300, opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: 300, opacity: 1 }),
        animate('250ms ease-in', style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
})
export class TechErrorDialogComponent implements OnInit {
  public panelOpenState: boolean = false;
  public isScientific: boolean = true;
  public titleError: string;
  public textContentError: string;
  public imgError: string;
  public textCodeError: string;
  public showTechExpasionPanel: boolean = false;
  public showHeaderExpasionPanel: boolean = false;
  public onlytext: boolean = false;
  is401: boolean = false;
  customTheme = localStorage.getItem('ThemeImg');

  constructor(
    private dialogService: TechDialogsService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<TechErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TechErrorDialogModel,
    private router: Router
  ) {}

  ngOnInit() {
    // this.data.status = 409; //OJO!!! Harcodeo
    // this.data.code = '1234-1234-CODE_DEMO'; //OJO!!! Harcodeo
    this.textCodeError = this.data.code;
    this.is401 = false;
    this.dialogRef.disableClose = false;
    switch (this.data.status) {
      case 500:
        this.translate.get('k003095').subscribe((text: string) => {
          //Token: Oupsh... algo no ha ido como esperábamos;
          this.titleError = text;
        });
        this.translate.get('k003096').subscribe((text: string) => {
          //Token: <p>Parece que el condensador de fluzo de <span class="blue">{0}</span> se ha desconectado repentinamente.</p><p>Póngase en contacto con nosotros en <span class="blue">{1}</span> y resolveremos la dudas que puedan surgirle. Puede que le solicitemos los detalles de la pestaña inferior.</p>;
          this.textContentError = text
            .replace('{0}', AppConfig.settings.entityName)
            .replace('{1}', AppConfig.settings.ContactEmailOperations);
        });
        if (this.data.error.ExceptionCode) {
          this.textCodeError = this.data.error.ExceptionCode;
        }
        this.imgError =
          './assets/img/' +
          localStorage.getItem('ThemeImg') +
          '/error/scientific.png';
        this.showHeaderExpasionPanel = true;
        console.log(this.data.error);
        break;
      case 401:
        this.is401 = true;
        this.dialogRef.disableClose = true;
        this.translate.get('k003097').subscribe((text: string) => {
          //Token: Vaya! Esto no nos lo esperábamos;
          this.titleError = 'Your session has expired';
        });
        break;

      case 400:
      case 402:
      case 403:
      case 404:
      case 405:
      case 406:
      //case 409:
      case 415:
        this.translate.get('k003097').subscribe((text: string) => {
          //Token: Vaya! Esto no nos lo esperábamos;
          this.titleError = text;
        });
        this.translate.get('k003098').subscribe((text: string) => {
          //Token: <p>Nuestro T-800 va a buscar ayuda para solucionar el problema. Estaremos listos y funcionando en breve.</p><p>Póngase en contacto con nosotros en <span class="blue">{0}</span> y resolveremos la dudas que puedan surgirle.</p>;
          this.textContentError =
            text.replace('{0}', AppConfig.settings.ContactEmailOperations) +
            ' (' +
            this.data.status +
            ')';
        });
        this.imgError =
          './assets/img/' +
          localStorage.getItem('ThemeImg') +
          '/error/robot.png';
        break;
      case 409:
        this.onlytext = true;
        this.translate.get('k003097').subscribe((text: string) => {
          //Token: Vaya! Esto no nos lo esperábamos;
          this.titleError = text;
        });
        this.translate.get('k003423').subscribe((text: string) => {
          //Token: It seems that there's a conflict and we apologize for the inconvenience.
          this.textContentError = '<p>' + text + '</p>';
        });
        this.textContentError += '<p>' + this.data.error.Message + '</p>';
        this.translate.get('k003424').subscribe((text: string) => {
          //Token: Ponte en contacto con nosotros en {0} y resolveremos las dudas que puedan surgir.
          this.textContentError += '<p>' + text + '</p>';
          this.textContentError = this.textContentError.replace(
            '{0}',
            AppConfig.settings.ContactEmailOperations
          );
        });
        break;
      default:
        this.onlytext = true;
        this.translate.get('k003097').subscribe((text: string) => {
          //Token: Vaya! Esto no nos lo esperábamos;
          this.titleError = text;
          this.textContentError = this.data.error.ExceptionMessage;
        });
        break;
    }
    // console.log('dialogErrorData', this.data);
  }

  public copyCode(code) {
    return `${code}\n\ncopied from timdeschryver.dev`;
  }

  public clickTechExpasionPanel() {
    this.showTechExpasionPanel = !this.showTechExpasionPanel;
  }

  public goOut(): void {
    this.dialogService.displayedModal = false;
    this.dialogRef.close();
  }

  public goOut2(): void {
    this.dialogService.displayedModal = false;
    this.dialogRef.close();
    this.router.navigate(['/login']);
  }

  public extractCode(message: string): string {
    let code: string;
    let index = message.indexOf('code') + 5;
    code = message.substring(index, index + 36);
    return code;
  }
}
